import { useQuery } from 'hooks/useCustomQuery';
import { useSelector, useDispatch } from 'react-redux';
import { axios } from '../../../../../services/axios';

const fetchPartners = async (currentScope, currentWholesaler) => {
    const endpoint =
        currentScope < 80 ? `/partners/${currentWholesaler}` : '/partners/all';
    const response = await axios.get(endpoint);
    return response.data;
};

const useGetAllPartners = (setTableData) => {
    const dispatch = useDispatch();
    const { currentScope } = useSelector((state) => state.login);
    const { currentWholesaler } = useSelector((state) => state.navigationLists);

    return useQuery({
        queryKey: ['partners', currentScope],
        queryFn: () => fetchPartners(currentScope, currentWholesaler),
        onSuccess: (data) => {
            setTableData((prev) => ({
                ...prev,
                data: data || [],
            }));
            // Dispatch AFTER data is successfully loaded
            dispatch({ type: 'CHANGE_TABLE_LOADING' });
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};

export default useGetAllPartners;
